module.exports = __webpack_public_path__ + "static/media/AML Penalties Main.2f0fdb19.svg";